import { Component, ViewChild, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToasterService, ToasterConfig } from 'angular2-toaster/angular2-toaster';
import { LocalUtils } from '../../restricted/restricted.utils';
import { AuthenticationService } from '../../auth/authentication.service';
import { HeaderService } from './app.header.service';
import { Router, NavigationEnd } from '@angular/router';
import { AppConfig } from '../../app.config';
import { ErrorsComponent } from '../../errors/errors.component';
import * as moment from 'moment';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements AfterViewInit, OnDestroy {

  @BlockUI() blockUI: NgBlockUI;
  @ViewChild('passwordModal') public passwordModal: ModalDirective;
  @ViewChild('languageModal') public languageModal: ModalDirective;
  @ViewChild('lunchModal') public lunchModal: ModalDirective;
  user: any = {};
  locale: any = {};
  model: any = {};
  public language = [];
  public room: any = {};
  public recipient: any = {};
  public protocol;
  public locales = [];
  users: any = [];
  sidebarOpen: boolean = false;
  colors = LocalUtils.colorsDefault;
  images = LocalUtils.imagesDefault;
  menu
  minimizer;
  public meeting: any = {
    session: false
  };
  public ua: any;
  public content: any;
  public register: boolean = false;
  inDashboard = false;
  public languages = []
  public imgProfile = 'https://onpeopleprofile.s3.sa-east-1.amazonaws.com/default.jpg';

  public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });

  constructor(private toasterService: ToasterService,
    private authService: AuthenticationService,
    private headerService: HeaderService,
    private _router: Router,
    private config: AppConfig,
    private errors: ErrorsComponent,
    private localUtils: LocalUtils) {

    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    //this.locales = this.user.organization.locales.sort(this.predicateBy('name'));

    this.getMeetingrooms();
    this.getLanguages();

    HeaderService.minimized.subscribe(r => {
      if (r) {
        this.images.logo = this.images.miniLogo;
        this.images.logoHeight = 24;
        this.images.logoWidth = 24;
        this.images.divWidth = 50;
        this.images.divHeight = 60;
        this.images.marginTop = 18;
        this.images.minimized = true;
      } else {
        this.images.logo = this.images.logo2;
        this.images.logoHeight = 35;
        this.images.logoWidth = 150;
        this.images.divWidth = 250;
        this.images.divHeight = 60;
        this.images.marginTop = 12;
        this.images.minimized = false;
      }
    });

    if (localStorage.getItem('profile')) {
      this.imgProfile = localStorage.getItem('profile');
    }

    HeaderService.navbarImages.subscribe(r => {
      if (r.logo) {
        this.images.logo = r.logo;
        this.images.logo2 = r.logo;
      }
      if (r.miniLogo) {
        this.images.miniLogo = r.miniLogo;
        if (this.images.minimized) {
          this.images.logo = r.miniLogo;
        }
      }
    });

    HeaderService.changeRoom.subscribe(() => {
      this.getMeetingrooms();
    });

    HeaderService.userUpdated.subscribe(item => {
      this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
      this.locales = this.user.organization.locales.sort(this.predicateBy('name'));
    });

    // LocalUtils.timestamps(this.user);
    // setInterval(() => {
    //   LocalUtils.timestamps(this.user);
    // }, 7200000);

    HeaderService.meeting.subscribe(r => {
      this.meeting = r;
      HeaderService.ua.emit(this.ua);
    });

    this._router.events.subscribe(() => {
      if (this._router.url == '/restricted/dashboard') {
        this.inDashboard = true;
      } else {
        this.inDashboard = false;
      }
    });

  }

  ngAfterViewInit() {
    this.verifyImageProfile();
    this.localeOpen();

    this.getIntegrations();
    HeaderService.sidebar.subscribe(r => {
      this.menu = r;
      this.saveSidebar(this.menu, this.minimizer);
    });
    HeaderService.minimized.subscribe(r => {
      this.minimizer = r;
      this.saveSidebar(this.menu, this.minimizer);
    });
    switch (localStorage.getItem('sidebarState')) {
      case '1': { };
        break;
      case '2': { document.getElementById('menuToState') ? document.getElementById('menuToState').click() : null };
        break;
      case '3': {
        if (document.getElementById('menuToState')) {
          document.getElementById('menuToState').click();
          document.getElementById('minimizerToState').click();
        }
      };
        break;
      default: { };
    }
  }

  saveSidebar(menu, minimizer) {
    if (!menu) {
      localStorage.setItem('sidebarState', '1');
    } else if (!minimizer) {
      localStorage.setItem('sidebarState', '2');
    } else {
      localStorage.setItem('sidebarState', '3');
    }
  }

  async ngOnInit() {
    this.language = await this.localUtils.getUserLanguage()
  }

  ngOnDestroy() {
    HeaderService.navbarColor.unsubscribe();
  }

  vendas() {
    this._router.navigateByUrl('/restricted/venda/page/1');
  }

  compras() {
    this._router.navigateByUrl('/restricted/compra/page/1');
  }

  hubspot() {
    this._router.navigateByUrl('/restricted/hubspot');
  }

  estoque() {
    this._router.navigateByUrl('/restricted/estoque');
  }

  usuarios() {
    this._router.navigateByUrl('/restricted/usuario');
  }

  dashboard(route) {
    this.blockUI.start('Um momento...');
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.user.myCalendar = false;

    if (route == 'OnWeb') {
      this.user.myRoom = {
        type: 'OnWeb',
        room: 'Webconferência'
      };
      this.updateUser()
      HeaderService.dashboard.emit('OnWeb');
      this._router.navigateByUrl('/restricted/dashboard');
    }

    if (route == 'OnRoom') {
      this.user.myRoom = {
        type: 'OnRoom',
        name: 'Salas'
      };
      this.updateUser()
      HeaderService.dashboard.emit('OnRoom');
      this._router.navigateByUrl('/restricted/dashboard');
    }

    if (route == 'OnDesk') {
      this.user.myRoom = {
        type: 'OnDesk',
        name: 'Posições'
      };
      this.updateUser()
      HeaderService.dashboard.emit('OnDesk');
      this._router.navigateByUrl('/restricted/dashboard');
    }

    if (route == 'Department') {
      this.user.myRoom = {
        type: 'Department',
        name: 'Departamento'
      };
      this.updateUser()
      this._router.navigateByUrl('/restricted/department');
    }

    if (route == 'OnVideo') {
      this.user.myRoom = {
        type: 'OnVideo',
        room: 'Videoconferência'
      };
      this.updateUser()
      HeaderService.dashboard.emit('OnVideo');
      this._router.navigateByUrl('/restricted/dashboard');
    }

    if (route == 'OnUC') {
      this.user.myRoom = {
        type: 'OnUC',
        name: 'Telefonia'
      };
      this.updateUser()
      this._router.navigateByUrl('/restricted/uc');
    }
  }

  openLunchModal() {
    this.model = {
      startLunchBreak: this.user.startLunchBreak,
      endLunchBreak: this.user.endLunchBreak
    };
    this.lunchModal.show();
  }

  saveLunchBreak() {
    return;
  }

  updateUser() {
    localStorage.setItem("user", LocalUtils.encrypt(JSON.stringify(this.user)));
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.blockUI.stop();
  }

  hasOnProductType(product) {
    if (
      (this.user.rooms && this.user.rooms.filter(room => room && room.product && room.product.infrastructure && room.product.infrastructure.platform && room.product.infrastructure.platform == product).length > 0) ||
      (this.user.shares && this.user.shares.filter(room => room && room.product && room.product.infrastructure && room.product.infrastructure.platform && room.product.infrastructure.platform == product).length > 0)
    ) {
      return true;
    } else {
      return false;
    };
  }

  myCalendar() {
    this.blockUI.start('Trocando o calendário');
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.user.myCalendar = true;
    localStorage.setItem("user", LocalUtils.encrypt(JSON.stringify(this.user)));
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.blockUI.stop();
    this._router.navigateByUrl('/restricted/oncalendarconfig');
  }

  myRoom(my) {
    if (this.user.rooms.length < 1) {
      this.otherRoom(my);
      return;
    }
    this.blockUI.start('Trocando a sala');
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.user.myRoom = this.user.rooms[my];
    this.user.myCalendar = false;
    localStorage.setItem("user", LocalUtils.encrypt(JSON.stringify(this.user)));
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    HeaderService.changeRoom.emit(true);
    setTimeout(() => {
      this.blockUI.stop();
      this._router.navigateByUrl('/restricted/meeting');
    }, 2000);
  }

  otherRoom(my) {
    this.blockUI.start('Trocando a sala');
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.user.myRoom = this.user.shares[my];
    this.user.myCalendar = false;
    localStorage.setItem("user", LocalUtils.encrypt(JSON.stringify(this.user)));
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    setTimeout(() => {
      HeaderService.changeRoom.emit(true);
      setTimeout(() => {
        this.blockUI.stop();
        this._router.navigateByUrl('/restricted/meeting');
      }, 2000);
    }, 2000);
  }

  meetingroom(me) {
    this.blockUI.start('Trocando a sala');
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    this.user.myRoom = this.user.meetingrooms[me];
    this.user.myCalendar = false;
    localStorage.setItem("user", LocalUtils.encrypt(JSON.stringify(this.user)));
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));
    setTimeout(() => {
      HeaderService.changeRoom.emit(true);
      setTimeout(() => {
        this.blockUI.stop();
        this._router.navigateByUrl('/restricted/meetingroom');
      }, 2000);
    }, 2000);
  }

  getIntegrations() {
    return
  }

  getMeetingrooms() {
    return
  }

  passwordOpen() {
    this.model = JSON.parse(JSON.stringify({}));
    this.passwordModal.show();
  }

  languageOpen() {
    this.model = JSON.parse(JSON.stringify({}));
    this.model = this.user
    this.languageModal.show();
  }

  localeOpen() {
    // this.locales = this.user.organization.locales.sort(this.predicateBy('name'));
    // if (this.user.localeId === null && this.locales.length > 0) {
    //   this.model = JSON.parse(JSON.stringify({}));
    // }
    return
  }

  changePassword() {
    if (!this.model.password || !this.model.password2 || !this.model.oldpassword) {
      return this.toasterService.pop('warning', 'Valor inválido', 'Preencha os campos corretamente!');
    }
    if (this.model.password != this.model.password2) {
      return this.toasterService.pop('warning', 'Valor inválido', 'Senhas não conferem');
    }
    if (this.model.password.length > 50 || this.model.password2.length > 50) {
      return this.toasterService.pop('warning', 'Valor inválido', 'Senhas não deve conter mais que 50 caracteres');
    }
    if (this.model.password.length < 5 || this.model.password2.length < 5) {
      return this.toasterService.pop('warning', 'Valor inválido', 'Senhas deve possuir mais que 5 caracteres');
    }

    this.blockUI.start('Trocando a senha');

    this.authService
      .changePassword(this.user.email, this.model.oldpassword, this.model.password)
      .subscribe(() => {
        this.toasterService.pop('success', 'Senha alterada com sucesso!');
        this.passwordModal.hide();
        this.blockUI.stop();
      },
        error => {
          this.passwordModal.hide();
          this.blockUI.stop();
          if (error.status == 404) {
            this.toasterService.pop('warning', 'Valor inválido', 'Senha atual incorreta');
          } else {
            this.toasterService.pop('danger', 'Erro não especificado', 'Ocorreu um erro ao alterar a senha, tente novamente mais tarde');
          }
        });
  }

  logout() {
    this.authService.logout();
  }

  sidebar() {
    this.headerService.sidebarEmit(!this.sidebarOpen);
    this.sidebarOpen = !this.sidebarOpen;
  }

  add() {
    HeaderService.add.emit(true);
  }

  setting() {
    HeaderService.setting.emit(true);
  }

  feedback() {
    HeaderService.feedback.emit(true);
  }

  setUser(user) {
    localStorage.setItem("user", LocalUtils.encrypt(JSON.stringify(user)));
    HeaderService.changeLocale.emit(JSON.stringify(user));
  }

  predicateBy(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    }
  }

  getLanguages() {
    return
  }

  updateLanguage() {
    return
  }

  verifyImageProfile() {
    return false
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-header/app-header.component.ts